document.addEventListener("DOMContentLoaded", function () {
  const fixedBnr = document.querySelector(".fixed_bnr");
  if (!fixedBnr) return; // .fixed_bnrが存在しない場合は何もしない

  const btn = fixedBnr.querySelector(".btn a");
  if (!btn) return; // ボタンが存在しない場合も何もしない

  btn.addEventListener("click", function (e) {
    e.preventDefault();
    fixedBnr.classList.add("is-hidden");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // モーダルの要素
  const modal = document.querySelector(".device_modal");
  if (!modal) return;

  // 開くボタン
  const openBtns = document.querySelectorAll(".js-device-modal-open");
  openBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      modal.classList.add("is-visible");
    });
  });

  // 閉じる要素
  const closeElements = modal.querySelectorAll(".bg, .btn_close a");
  closeElements.forEach((el) => {
    el.addEventListener("click", function () {
      modal.classList.remove("is-visible");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if ($(".sec_faq").length) {
    $(".sec_faq .faq_ttl a").on("click", function (e) {
      e.preventDefault();

      const $this = $(this);
      const $content = $this.parent(".faq_ttl").next(".faq_content");

      // スライドトグル
      $content.stop().slideToggle(300);

      // .is-open クラスをトグル
      $this.toggleClass("is-open");
    });

    $(".sec_faq .question a").on("click", function (e) {
      e.preventDefault();

      const $this = $(this);
      const $content = $this.parent(".question").next(".answer");

      // スライドトグル
      $content.stop().slideToggle(300);

      // .is-open クラスをトグル
      $this.toggleClass("is-open");
    });
  }
});

window.addEventListener("load", function () {
  // タイトル要素にクラス付与
  const ttlElements = document.querySelectorAll(".js_mv_ttl");
  ttlElements.forEach(ttl => {
    ttl.classList.add("is-visible");
  });

  // Lottieプレイヤー
  const linePlayers = document.querySelectorAll(".js_mv_line");
  const bgPlayers = document.querySelectorAll(".js_mv_bg");

  // タイトルvisible後0msでlineアニメーション再生
  setTimeout(() => {
    linePlayers.forEach(player => {
      if (player.play) {
        player.play();
      }
    });
  }, 0);

  // DOM読み込み後1000msでbgアニメーション再生
  setTimeout(() => {
    bgPlayers.forEach(player => {
      if (player.play) {
        player.play();
      }
    });
  }, 1000);
});

window.addEventListener("load", function () {
  const lottieElements = document.querySelectorAll(".lottie_visible");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // is-visibleクラスを付与
          entry.target.classList.add("is-visible");
          // Lottieアニメーション再生
          entry.target.play();
          // 一度だけ発火させたい場合は監視解除
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -35% 0px',
      threshold: 0
    }
  );

  // 複数要素に対応
  lottieElements.forEach(el => observer.observe(el));
});